import React, { Component } from 'react';
import {subscribeUserFavourites, setUserProfile, updateUserFavourites} from "../../../actions/userProfileActions";
import {connect} from "react-redux";
import CTCAE_ROW_DATA from '../../../resources/ctcae6';
import Result from '../result/result';
import './favourites.css';

class Favourites extends Component {

    constructor() {
        super();
        this.state = {
            step: 0,
            code: 0
        }
    }

    handleSelect(event, code){
        event.preventDefault();
        console.log('handleSelect is called', code);
        this.setState({
            step: 1,
            code: code
        });
    };

    handleBack = event => {
        this.setState({
            step: 0
        });
    };

    // handleEdit(event, code){
    //     event.preventDefault();
    //     console.log('handleEdit is called', code);
    // }
    //
    // handleDelete(event, code){
    //     event.preventDefault();
    //     console.log('handleDelete is called', code);
    // }


    render() {

        if(this.state.step === 0){
            const uid = this.props.userProfile.uid;
            const favouriteList = this.props.userProfile.favourites;

            let self = this;
            let infoListView = null;

            if(uid && favouriteList){
                const favouriteCodeList = favouriteList.map(data => data.code);
                console.log("favouriteCodeList : ", favouriteCodeList);
                const filteredList = CTCAE_ROW_DATA.filter(data => (favouriteCodeList.indexOf(data.meddra_code) > -1 ));
                console.log("filteredList : ", filteredList);

                infoListView =
                    (
                        <div className="favourite-table-container">
                            <div className="table-responsive">
                                <table className="table table-striped table-hover">
                                    <tbody>
                                    <tr>
                                        <th>No</th>
                                        <th>Meddra Code</th>
                                        <th>Soc</th>
                                        <th>Term</th>
                                        <th>Note</th>
                                    </tr>
                                    {
                                        filteredList.map(function(item, i){
                                            return (
                                                <tr key={item.meddra_code} onClick={(e) => self.handleSelect(e, item.meddra_code)}>
                                                    <td>{i+1}</td>
                                                    <td>{item.meddra_code}</td>
                                                    <td>{item.meddra_soc}</td>
                                                    <td>{item.ctcae_term}</td>
                                                    <td>{self.getFavourite(favouriteList, item.meddra_code).note}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
            }

            return (
                <div className="favourite-container">
                    {infoListView}
                </div>
            );
        }else if(this.state.step === 1 ){

            const result = CTCAE_ROW_DATA.filter(data => (data.meddra_code === this.state.code))[0];

            console.log("props : ",this.props);
            console.log("final result : ",result);

            return (
                <div className="favourite-container">
                    <div className="row content-header">
                        <div className="col-sm-3">
                            <div className="title">
                                <button className="btn btn-default" onClick={this.handleBack}><i className="fa fa-arrow-left"/> Back to favourites</button>
                            </div>
                        </div>
                    </div>
                    <div className="content-body">
                        <Result result={result}/>
                    </div>
                </div>
            );
        }else{
            return (<div className="favourite-container"/>);
        }
    }

    getFavourite(favouriteList, code){
        return favouriteList.filter(item => item.code === code)[0];
    }
}

const mapStateToProps = state => ({
    userProfile: state.userProfile
});

export default connect(mapStateToProps, {setUserProfile, updateUserFavourites, subscribeUserFavourites} )(Favourites);


// WEBPACK FOOTER //
// ./src/component/ctcae6/favourites/favourites.js